import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ConfigFciRequest } from '../../requests/motor-fiscal/config-fci.request';
import { ConfigFciResponse } from '../../responses/motor-fiscal/config-fci.response';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
  providedIn: 'root',
})
export class ConfigFciService extends CommonService {
  private readonly apiUrl: string = environment.urlApiMotorFiscal + 'ConfiguracaoFci';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public get(): Observable<ConfigFciResponse> {
    return this.httpClient
      .get<ConfigFciResponse>(this.apiUrl, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public put(request: ConfigFciRequest): Observable<ReturnStruct> {
    return this.httpClient
      .put<ReturnStruct>(this.apiUrl, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
